<template>
  <SoAdminPageWithTabs :tabs="tabs" header-color="white">
    <template #tab-0>
      <div v-if="isMeteringUser" class="d-flex justify-end gap-2">
        <BulkSmartReadsImport />
        <BulkSmartMetersEligibleForExchangeImport
          v-if="isCommercialMeteringUser"
        />
        <SoButton
          title="SMEX waitlist"
          large
          :href="smexWaitlistUrl"
          target="_blank"
          data-testid="export-button"
        />
      </div>
      <OpsSmartMeterTable />
    </template>
    <template #tab-1>
      <div class="d-flex justify-end gap-2">
        <BulkInstallCodesImport />
      </div>
      <InstallCodesTable />
    </template>
  </SoAdminPageWithTabs>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { AuthService } from "@/services/AuthService"
  import { ROLES } from "@/services/PermissionsService"
  import SoButton from "@/components/formControls/SoButton.vue"
  import OpsSmartMeterTable from "./components/OpsSmartMeterTable.vue"
  import BulkSmartReadsImport from "./components/BulkSmartReadsImport.vue"
  import BulkSmartMetersEligibleForExchangeImport from "./components/BulkSmartMetersEligibleForExchangeImport.vue"
  import { externalRoutes } from "@/constants/routes/externalRoutes"
  import BulkInstallCodesImport from "./components/BulkInstallCodesImport.vue"
  import SoAdminPageWithTabs from "@/components/templates/SoAdminPageWithTabs.vue"
  import { ITab } from "@/types/Tabs.js"
  import InstallCodesTable from "./components/InstallCodesTable.vue"

  export default defineComponent({
    components: {
      OpsSmartMeterTable,
      SoButton,
      BulkSmartReadsImport,
      BulkSmartMetersEligibleForExchangeImport,
      BulkInstallCodesImport,
      SoAdminPageWithTabs,
      InstallCodesTable,
    },
    data() {
      return {
        tabs: [
          {
            title: "Smart meters",
          },
          {
            title: "Install codes",
          },
        ] as ITab[],
      }
    },
    computed: {
      isMeteringUser() {
        const roles: string[] = AuthService.getUserRoles()
        return (
          roles.includes(ROLES.METERING) ||
          roles.includes(ROLES.COMMERCIAL_METERING) ||
          roles.includes(ROLES.DEVELOPER)
        )
      },
      isCommercialMeteringUser() {
        const roles: string[] = AuthService.getUserRoles()
        return (
          roles.includes(ROLES.COMMERCIAL_METERING) ||
          roles.includes(ROLES.DEVELOPER)
        )
      },
      smexWaitlistUrl() {
        return externalRoutes.SmexWaitlist.path
      },
    },
  })
</script>
